import { ReactElement } from 'react'
import {
  Box,
  Button,
  Column,
  Columns,
  Dialog,
  IllustrationSuccess,
  Stack
} from '@machobear/design-system'

interface Button {
  text: string
  id?: string
  onClick?: () => void
}

interface Props {
  dialogId: string
  eventId?: string
  open: boolean
  onClose: () => void
  title: string
  description?: ReactElement | null
  icon?: React.ReactNode
  secondaryButtonText?: string
  secondaryOnSubmit?: () => void
  content?: ReactElement
  onSubmit: ((() => Promise<void>) | (() => void)) | null
  buttonText: string
}

export const SuccessModal: React.FC<Props> = ({
  dialogId,
  eventId,
  open,
  onClose,
  title,
  description,
  icon,
  secondaryButtonText,
  secondaryOnSubmit,
  content,
  buttonText,
  onSubmit
}) => {
  const handleOnClick = () => {
    if (eventId) {
      window.dataLayer.push({
        event: eventId
      })
    }
    onSubmit?.()
  }

  return (
    <Dialog
      id={dialogId}
      illustration={
        <Box marginTop="gutter" marginBottom="xxsmall">
          {icon ?? <IllustrationSuccess />}
        </Box>
      }
      title={title}
      description={description}
      open={open}
      onClose={onClose}
      width="xsmall"
    >
      <Stack space="large">
        {content}
        <Columns space="gutter">
          {secondaryButtonText ? (
            <Column width="1/2">
              <Button variant="ghost" onClick={secondaryOnSubmit}>
                {secondaryButtonText}
              </Button>
            </Column>
          ) : null}
          {buttonText ? (
            <Column>
              <Button variant="solid" onClick={handleOnClick}>
                {buttonText}
              </Button>
            </Column>
          ) : null}
        </Columns>
      </Stack>
    </Dialog>
  )
}
